<template>
  <div class="index-container">
    <img src="~assets/images/index/btn.png" class="btn" @click="enter" />
    <div class="img-wrap">
      <img src="~assets/images/index/bg.png" class="scale-bg" />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.share()
  },

  methods: {
    // 进入详情
    enter() {
      this.$emit('change-com', 'vr')
    },

    // 首页分享
    share() {
      const url = window.location.href
      const option = {
        shareTitle: '见证岁月 砥砺丹心',
        shareDesc: '董丹东捐赠作品特展',
        shareUrl: `${url}`,
        shareImg: `${url.split('#')[0]}share-pic.png`
      }
      this.ShareImpl(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.index-container {
  width: 100%;
  height: 100%;
  position: relative;
  .img-wrap {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    z-index: -1;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    box-sizing: border-box;
    .scale-bg {
      width: 100%;
      height: 100%;
    }
  }
  .btn {
    width: 300px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 65px;
    cursor: pointer;
  }
  .loading {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 80px;
    .loading-text {
      font-size: 32px;
      color: #f4df9c;
      font-weight: 500;
      margin-bottom: 44px;
      text-align: center;
    }
    .loading-bar {
      width: 414px;
      height: 12px;
      border: 1px solid #f4df9c;
      box-sizing: border-box;
      border-radius: 6px;
      position: relative;
      .loading-progress {
        background: #f4df9c;
        height: 100%;
        border-radius: 6px;
        position: absolute;
        left: 0;
        top: 0;
        transition: width 0.2s ease-out;
      }
    }
  }
}

@keyframes animatedBackground {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.35);
  }
  100% {
    transform: scale(1);
  }
}
</style>
